<template lang="html">
	<div class="patrimonial-form">
		<form class="form-ui landscape-patrimonial-ui" novalidate>
			<div class="label solo">
				Quand vous pensez à votre paysage patrimonial, qu'est-ce qui vous tient le plus à coeur ?
			</div>
			<textarea :class="{error: errors.has('motivation')}" v-validate="'required'" name="motivation" placeholder="Ex : Protéger votre conjoint(e), accompagner un enfant handicapé, préparer un tour du monde" v-model="motivation"></textarea>
			<div class="error-message">
				{{ errors.first('motivation') }}
			</div>
			<div class="label solo">
				Auprès de qui prenez-vous conseil ?
			</div>
			<div class="ctn-tags row">
				<div class="tag" v-for="(tag, key) in conselors" v-bind:key="key" :class="{active: isActiveTag(tag)}" @click="toggleTag(tag)">
					{{ tag }}
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'Influence',
	data () {
		return {
			conselors: [
				'Votre entourage',
				'La presse généraliste',
				'La presse économique',
				'Télévision radio',
				'Publicité financière',
				'Gestionnaire de patrimoine',
				'Site spécialisé',
				'Conseiller bancaire',
				'Agent d\'assurance'
			],
			selectedConselors: [],
			motivation: null
		}
	},
	mounted () {
		this.motivation = this.estate.influence.motivation || null
		this.selectedConselors = Array.from(this.estate.influence.conselors)
	},
	watch: {
		'estate.influence': {
			handler () {
				this.motivation = this.estate.influence.motivation || null
				this.selectedConselors = Array.from(this.estate.influence.conselors)
			},
			deep: true
		}
	},
	methods: {
		toggleTag (value) {
			if (this.selectedConselors.indexOf(value) === -1) {
				this.selectedConselors.push(value)
			} else {
				this.selectedConselors.splice(this.selectedConselors.indexOf(value), 1)
			}
		},
		isActiveTag (value) {
			return (this.selectedConselors.indexOf(value) !== -1)
		},
		validate () {
			return this.$validator.validate()
		},
		save () {
			return new Promise((resolve, reject) => {
				this.validate().then((validation) => {
					if (validation) {
						this.$store.dispatch('storePatrimonial', {
							name: 'INFLUENCE',
							data: {
								motivation: this.motivation,
								conselors: this.selectedConselors
							},
							fromStart: false
						}).then(() => {
							resolve()
						})
					}
				})
			})
		}
	},
	beforeDestroy () {
		this.save()
	},
	computed: {
		...mapGetters({
			estate: 'estate'
		})
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/common/components/MyPatrimonialLandscape/Influence.vue